import { useCart } from "lib/hooks/useCart";
import FormContainer from "components/forms/FormContainer/FormContainer";
import CheckoutForm from "components/forms/CheckoutForm/CheckoutForm";
import { postCheckout } from "lib/client-api/user/checkout";
import { checkoutFormSchema } from "components/forms/CheckoutForm/checkoutFormSchema";
import { getCookie } from "utils";

export default function Checkout({ onFormClose = () => {} }) {
  const { refreshCart } = useCart();

  const handleSubmit = async (data) => {
    const currencyCookie = getCookie("currency");
    const checkoutData = {
      ...data,
      metadata: {
        currency: JSON.parse(currencyCookie).code.toLowerCase() || "eur",
      },
    };

    const checkoutResponse = await postCheckout({ checkoutData });

    await refreshCart();

    return checkoutResponse;
  };
  return (
    <>
      <h1>Enquiry Form</h1>
      <FormContainer
        pageName="Checkout"
        submitHandler={handleSubmit}
        submitButtonText="Submit Enquiry"
        confirmationText={`Thanks for your enquiry! 
        We will be in touch soon to confirm your details and complete the booking.`}
        schema={checkoutFormSchema}
        onFormClose={onFormClose}
      >
        <CheckoutForm />
      </FormContainer>
    </>
  );
}
